module.exports = __webpack_public_path__ + "9cac65ab9f706702b75ebe6825fd4a0a.pdf";